import { useState } from "react";
import { Instagram, Copy } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { dmUrl } from "@/lib/api";

export const BookDmButton = ({ tech, className = "", size = "lg" }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(`Hi @${tech.username}! I found you on Nailora and I'd love to book a set. Date I'm hoping for: ___ . Style/length: ___ .`);
  const go = async () => {
    try { await navigator.clipboard.writeText(msg); toast.success("Message copied — paste it in the DM"); } catch { /* clipboard blocked */ }
    window.open(dmUrl(tech.username), "_blank", "noopener");
  };
  return (
    <>
      <button data-testid="book-via-ig-dm-button" onClick={(e) => { e.preventDefault(); setOpen(true); }}
        className={`ig-gradient inline-flex items-center justify-center gap-2 rounded-full font-medium text-white transition-transform duration-200 hover:-translate-y-0.5 active:scale-95 ${size === "lg" ? "px-7 py-3.5 text-sm" : "px-4 py-2 text-xs"} ${className}`}>
        <Instagram className="h-4 w-4" /> Book via Instagram DM
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="book-dm-dialog" className="max-w-md rounded-2xl bg-white p-8">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">Book with @{tech.username}</DialogTitle>
            <DialogDescription>{tech.booking_note || "Send them a DM with your inspo and preferred date."}</DialogDescription>
          </DialogHeader>
          <Textarea data-testid="book-dm-message" value={msg} onChange={(e) => setMsg(e.target.value)} rows={5} className="rounded-xl" />
          <button data-testid="book-dm-open-instagram" onClick={go} className="ig-gradient inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium text-white">
            <Copy className="h-4 w-4" /> Copy message & open Instagram DM
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
};
